export enum MapType {
    Google = 1,
    Bing,
}